<template>
  <model-form
    ref="modelForm"
    :model="transfer"
  >
    <q-tabs
      v-model="tab"
      dense
      class="text-grey"
      active-color="primary"
      indicator-color="primary"
      align="justify"
    >
      <q-tab
        name="payments"
        label="Payments"
      />
      <q-tab
        name="order-items"
        label="Order Items"
      />
      <q-tab
        name="voided-order-items"
        label="Voided Order Items"
      />
      <q-tab
        name="payment-disputes"
        label="Lost Disputes"
      />
      <q-tab
        name="details"
        label="Details"
      />
    </q-tabs>
    <q-tab-panels
      v-model="tab"
      animated
    >
      <q-tab-panel
        name="details"
      >
        <div>
          <div class="row q-gutter-md q-mb-md">
            <q-input
              :model-value="transfer.date"
              class="col"
              label="Date"
              readonly
            />
            <q-input
              :model-value="transfer.state"
              class="col"
              label="State"
              readonly
            />
            <q-input
              :model-value="transfer.computedAt"
              class="col"
              label="Computed At"
              readonly
            />
            <q-input
              :model-value="transfer.transferInitiationDate"
              class="col"
              label="Scheduled Transfer Start Date (GMT)"
              readonly
            />
            <q-input
              :model-value="transfer.transferedAt"
              class="col"
              label="Transfered At"
              readonly
            />
          </div>
          <div class="row q-gutter-md q-mb-md">
            <q-input
              :model-value="transfer.cashPaymentTotal"
              class="col"
              label="Cash Payment Total"
              :prefix="currentCircuit.localeCurrencySymbol"
              readonly
            />
            <q-input
              :model-value="transfer.cashPaymentCount"
              class="col"
              label="Cash Payment Count"
              readonly
            />
            <q-input
              :model-value="transfer.cashRefundTotal"
              class="col"
              label="Cash Refund Total"
              :prefix="currentCircuit.localeCurrencySymbol"
              readonly
            />
            <q-input
              :model-value="transfer.cashRefundCount"
              class="col"
              label="Cash Refund Count"
              readonly
            />
          </div>
          <div class="row q-gutter-md q-mb-md">
            <q-input
              :model-value="transfer.creditCardPaymentTotal"
              class="col"
              label="Credit Card Payment Total"
              :prefix="currentCircuit.localeCurrencySymbol"
              readonly
            />
            <q-input
              :model-value="transfer.creditCardPaymentCount"
              class="col"
              label="Credit Card Payment Count"
              readonly
            />
            <q-input
              :model-value="transfer.creditCardRefundTotal"
              class="col"
              label="Credit Card Refund Total"
              :prefix="currentCircuit.localeCurrencySymbol"
              readonly
            />
            <q-input
              :model-value="transfer.creditCardRefundCount"
              class="col"
              label="Credit Card Refund Count"
              readonly
            />
          </div>
          <div class="row q-gutter-md q-mb-md">
            <q-input
              v-model="transfer.lostDisputesTotal"
              class="col"
              label="Lost Disputes Total"
              :prefix="currentCircuit.localeCurrencySymbol"
              readonly
            />
            <q-input
              v-model="transfer.lostDisputesFee"
              class="col"
              label="Lost Disputes Stripe Fee"
              :prefix="currentCircuit.localeCurrencySymbol"
              readonly
            />
            <q-input
              v-model="transfer.lostDisputesCount"
              class="col"
              label="Lost Disputes Count"
              readonly
            />
          </div>
          <div
            class="row q-gutter-md q-mb-md"
          >
            <q-input
              :model-value="transfer.externalTicketingPaymentTotal"
              class="col"
              label="External Ticketing Payment Total"
              :prefix="currentCircuit.localeCurrencySymbol"
              readonly
            />
            <q-input
              :model-value="transfer.externalTicketingPaymentCount"
              class="col"
              label="External Ticketing Payment Count"
              readonly
            />
            <q-input
              :model-value="transfer.externalTicketingRefundTotal"
              class="col"
              label="External Ticketing Refund Total"
              :prefix="currentCircuit.localeCurrencySymbol"
              readonly
            />
            <q-input
              :model-value="transfer.externalTicketingRefundCount"
              class="col"
              label="External Ticketing Refund Count"
              readonly
            />
          </div>
          <div class="row q-gutter-md q-mb-md">
            <q-input
              :model-value="transfer.priorDayUnclaimedExternalTicketingRefundTotal"
              class="col"
              label="Prior Day Unclaimed External Ticketing Refund Total"
              :prefix="currentCircuit.localeCurrencySymbol"
              readonly
            >
              <q-tooltip>
                <q-icon name="info" />
                <span>
                  External Ticketing Refunds will subtract from the External Ticketing payout as long as it it remains positive. Any amount remaining will be added to the next day's External Ticketing payout.
                </span>
              </q-tooltip>
            </q-input>
            <q-input
              :model-value="transfer.unclaimedExternalTicketingRefundTotal"
              class="col"
              label="Today's Unclaimed External Ticketing Refund Total"
              :prefix="currentCircuit.localeCurrencySymbol"
              readonly
            >
              <q-tooltip>
                <q-icon name="info" />
                <span>
                  External Ticketing Refunds will subtract from the External Ticketing payout as long as it it remains positive. Any amount remaining will be added to the next day's External Ticketing payout.
                </span>
              </q-tooltip>
            </q-input>
          </div>
          <div class="row q-gutter-md q-mb-md">
            <q-input
              :model-value="transfer.creditCardPaymentTotal - transfer.creditCardRefundTotal"
              class="col"
              label="Credit Card Net"
              :prefix="currentCircuit.localeCurrencySymbol"
              readonly
            />
            <q-input
              :model-value="-transfer.stripeFee"
              class="col"
              label="Stripe Fee"
              :prefix="currentCircuit.localeCurrencySymbol"
              readonly
            />
            <q-input
              v-if="transfer.hasStripeTax"
              :model-value="-transfer.stripeFeeTax"
              class="col"
              label="Stripe Fee Tax"
              :prefix="currentCircuit.localeCurrencySymbol"
              readonly
            />
            <q-input
              v-if="transfer.hasStripeTax"
              :model-value="-transfer.stripeFeeNet"
              class="col"
              label="Stripe Fee Net"
              :prefix="currentCircuit.localeCurrencySymbol"
              readonly
            />
            <q-input
              :model-value="-transfer.indyFee"
              class="col"
              label="INDY Fee"
              :prefix="currentCircuit.localeCurrencySymbol"
              readonly
            />
            <q-input
              v-if="transfer.indyFeeCapSavings"
              :model-value="transfer.indyFeeCapSavings"
              class="col"
              label="INDY Fee Cap Savings"
              :prefix="currentCircuit.localeCurrencySymbol"
              readonly
            />
            <q-input
              v-if="transfer.priorDayBalance"
              :model-value="transfer.priorDayBalance"
              class="col"
              label="Prior Balance"
              :prefix="currentCircuit.localeCurrencySymbol"
              readonly
            />
          </div>
          <div class="row q-gutter-md q-mb-md">
            <q-input
              :model-value="transfer.totalSitePayout"
              class="col"
              label="Payout Total"
              :prefix="currentCircuit.localeCurrencySymbol"
              readonly
            />
            <q-input
              :model-value="transfer.indySiteSalesPayout"
              class="col"
              label="Indy Sales Payout Total"
              :prefix="currentCircuit.localeCurrencySymbol"
              readonly
            />
            <q-input
              :model-value="transfer.externalSiteTicketingPayout"
              class="col"
              label="External Ticketing Payout Total"
              :prefix="currentCircuit.localeCurrencySymbol"
              readonly
            />
          </div>
          <div
            v-if="currentUser && currentUser.superUser"
            class="row q-gutter-md q-mb-md"
          >
            <q-input
              :model-value="transfer.indyFixedDailyFee"
              class="col"
              label="INDY Fixed Daily Fee"
              :prefix="currentCircuit.localeCurrencySymbol"
              readonly
            />
            <q-input
              :model-value="transfer.indyFee"
              class="col"
              label="INDY Fee Total"
              :prefix="currentCircuit.localeCurrencySymbol"
              readonly
            />
            <q-input
              v-if="transfer.indyFixedServicesDailyFee > 0"
              :model-value="transfer.indyFixedServicesDailyFee"
              class="col"
              label="INDY Fixed Services Fee Total"
              :prefix="currentCircuit.localeCurrencySymbol"
              readonly
            />
            <q-input
              :model-value="transfer.priorDayIndyBalance"
              class="col"
              label="Prior Day Balance"
              :prefix="currentCircuit.localeCurrencySymbol"
              readonly
            />
            <q-input
              :model-value="transfer.indyTransferTotal"
              class="col"
              label="INDY Transfer"
              :prefix="currentCircuit.localeCurrencySymbol"
              readonly
            />
          </div>
          <div
            class="row q-gutter-md q-mb-md"
          >
            <q-input
              :model-value="transfer.circuitTransferId"
              class="col"
              label="Circuit Transfer ID"
              readonly
            />
            <q-input
              :model-value="transfer.transferError"
              class="col"
              label="Transfer Error"
              readonly
            />
          </div>
          <transfer-payout-table
            :transfer-payouts="transfer.transferPayouts"
            :show-indy-payouts="currentUser && currentUser.superUser"
          />
        </div>
      </q-tab-panel>
      <q-tab-panel
        name="payments"
      >
        <payment-table
          :transfer-id="transfer.id"
          :descending="false"
          show-fees
        />
      </q-tab-panel>
      <q-tab-panel
        name="order-items"
      >
        <order-item-table
          :transfer-id="transfer.id"
          :descending="false"
        />
      </q-tab-panel>
      <q-tab-panel
        name="voided-order-items"
      >
        <order-item-table
          :void-transfer-id="transfer.id"
          :descending="false"
        />
      </q-tab-panel>
      <q-tab-panel
        name="payment-disputes"
      >
        <payment-dispute-table
          :transfer-id="transfer.id"
          :descending="false"
        />
      </q-tab-panel>
    </q-tab-panels>
  </model-form>
</template>

<script>

import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'
import OrderItemTable from 'src/modules/admin/order/OrderItemTable'
import PaymentDisputeTable from 'src/modules/admin/payment/PaymentDisputeTable'
import PaymentTable from 'src/modules/admin/payment/PaymentTable'
import TransferPayoutTable from 'src/modules/admin/transfer/TransferPayoutTable'

export default {
  name: 'UserForm',
  components: {
    ModelForm,
    PaymentTable,
    OrderItemTable,
    PaymentDisputeTable,
    TransferPayoutTable
  },
  data: function () {
    return {
      tab: 'payments'
    }
  },
  context: ['currentUser'],
  configuration: ['currentCircuit', 'currentSite'],
  models: {
    transfer: {
      transferPayouts: true
    }
  },

  methods: {
    show (model, initialData, tab) {
      this.tab = tab || 'details'
      this.$refs.modelForm.show(model, initialData)
    }
  }
}

</script>
